import { render, staticRenderFns } from "./chat-window-input.vue?vue&type=template&id=0987d18a&scoped=true&"
import script from "./chat-window-input.vue?vue&type=script&lang=js&"
export * from "./chat-window-input.vue?vue&type=script&lang=js&"
import style0 from "./chat-window-input.vue?vue&type=style&index=0&id=0987d18a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0987d18a",
  null
  
)

export default component.exports